<template>
  <div class="app-main-content bill-overseas-s-center-view">
    <div
      class="main-content"
      type="primary"
    >
      <query-bill-oversea-condition
        ref="queryBillOverseaCondition"
        :source-submit-state="2"
        :bill-state="1"
      >
        <template slot="operations">
          <div style="float: left;">
            <el-button style="margin-left: 10px" type="primary" @click="toQuery()">
              {{ $t('CargoMsg.Cargo_Query') }}
            </el-button>
            <el-button v-show="$checkPermission(['button_BillOverseasSCenter_Submit'])" type="primary" @click="toSubmit()">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
            <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
          </div>
          <div style="float: right; display: flex">
            <div style="margin-top: 6px;">{{ $t('CargoMsg.Cargo_AllAmountP')+rowData.length }}</div>
            <div style="margin: 6px 10px;">{{ $t('CargoMsg.Cargo_SelectedItems',['['+selectedRows.length+']']) }}</div>
            <span class="totalLabel">{{ $t('CargoMsg.Cargo_CreditAmountTo') }}</span>
            <el-input v-model="sumCredit" disabled style="width: 80px" />
            <span class="totalLabel">{{ $t('CargoMsg.Cargo_DebitAmountTo') }}</span>
            <el-input v-model="sumDebit" disabled style="width: 80px" />
          </div>
        </template>
      </query-bill-oversea-condition>
    </div>
    <bill-overseas-s-center-grid
      config-module="410015201"
      :row-data="rowData"
      :filter="filter"
      :grid-options="gridOptions"
    />
  </div>
</template>

<script>
import QueryBillOverseaCondition
  from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillOverseaCondition'
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import BillOverseasSCenterGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSCenterGrid'
import { queryBillOverseas, batchUpdateStates } from '@/api/clearing/billingNative'
import StrUtils from '@/utils/StrUtils'
export default {
  name: 'BillOverseasSCenterView',
  components: { BillOverseasSCenterGrid, AmountSumMaster, QueryBillOverseaCondition },
  data() {
    return {
      fullscreenLoading: null,
      rowData: [],
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      filter: {
        pageNum: 1,
        pageSize: 100
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
          this.caculateAmount()
        }
      }
    }
  },
  methods: {
    toQuery() {
      const option = this.$refs['queryBillOverseaCondition'].getSearchOption()
      if (option.isMerge && !option.hasOwnProperty('accountId')) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      option['limit'] = this.filter.pageSize
      option.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryBillOverseas(option).then(res => {
        this.rowData = res.data
        this.loadingEnd()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
      this.caculateAmount()
    },
    toSubmit() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (StrUtils.isEmpty(billing.billingNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted'))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureDoThis'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        if (this.checkSubmitBilling()) {
          // 退回到已打印状态
          this.fullscreenLoading = getLoading()
          batchUpdateStates(selectRows, { state: 4 }).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
            this.gridOptions.api.updateRowData({ 'remove': selectRows })
            this.loadingEnd()
          }).catch(() => {
            this.fullscreenLoading.close()
          })
        }
      })
    },
    checkSubmitBilling() {
      for (const bill of this.selectedRows) {
        if (bill.state === 4 || bill.state === 5) {
          this.$message.warning(StrUtils.substitute(this.$t('CargoMsg.Cargo_BillHasBeenSubmitted'), bill.billingNo))
          return false
        }
      }
      return true
    },
    resetSearch() {
      this.$refs['queryBillOverseaCondition'].resetSearch()
    },
    caculateAmount() {
      let credit = 0
      let debit = 0
      for (const cg of this.selectedRows) {
        if (cg.ar) { debit += cg.amount } else { credit += cg.amount }
      }
      this.sumCredit = credit.toFixed(2)
      this.sumDebit = debit.toFixed(2)
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
